import { Suspense } from 'react'

import { AnyRoute, Outlet, createRoute, redirect } from '@tanstack/react-router'
import { BANK_USERS_PATH } from 'commons/constants/routes'
import { CircularProgress } from 'ui/components'

import { usersRoute } from './Users'

export const bankUsersRoutingNode = <T extends AnyRoute>(rootRoute: T) => {
  const usersIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.userRootAccess) {
        throw redirect({
          to: '/'
        })
      }
    },
    getParentRoute: () => rootRoute,
    path: BANK_USERS_PATH,
    component: () => (
      <Suspense fallback={<CircularProgress centered />}>
        <Outlet />
      </Suspense>
    )
  })

  return usersIndexRoute.addChildren([usersRoute<typeof usersIndexRoute>(usersIndexRoute)])
}
